// extracted by mini-css-extract-plugin
export var addressFields = "_mv-0";
export var animationContainer = "_mv-1";
export var footer = "_mv-2";
export var lineItems = "_mv-3";
export var modalContent = "_mv-4";
export var orderName = "_mv-5";
export var strong = "_mv-6";
export var warning = "_mv-7";